import Reset16 from '@carbon/icons-react/es/reset/16';
import { Tooltip } from 'antd';
import React, { FC } from 'react';
import { NotificationStatus } from 'api/notifications';
import { Button } from 'components/atoms/button';
import { Clear16 } from 'components/atoms/icons';
import { useTranslation } from 'hooks/use-translation';
import { ActionableGroup } from 'stores/notifications/models';
import styles from './group.module.css';

export const Hanger: FC<{ group: ActionableGroup }> = ({ group }) => {
  const clearTitle = useTranslation('notifications.commands.clear');
  const unclearTitle = useTranslation('notifications.commands.unclear');

  return (
    <>
      {group.status === NotificationStatus.New && (
        <Tooltip title={clearTitle}>
          <Button
            className={styles.button}
            type="text"
            icon={<Clear16 />}
            onClick={(e) => {
              e.stopPropagation();
              group.clear();
            }}
          />
        </Tooltip>
      )}
      {group.status === NotificationStatus.Cleared && (
        <Tooltip title={unclearTitle}>
          <Button
            className={styles.button}
            type="text"
            icon={<Reset16 />}
            onClick={(e) => {
              e.stopPropagation();
              group.unclear();
            }}
          />
        </Tooltip>
      )}
    </>
  );
};
